var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-front"},[_c('h3',[_vm._v("booking.eontyre.com")]),_c('p',[_vm._v("Nothing to see here...")])])}]

export { render, staticRenderFns }